import { apiAgent } from "../../../axiosConfig"
import getApiUrl from "../../utils/UrlHelper"

export const create_or_update_report = (data_params) => {
    return apiAgent({
        method: "post",
        url: getApiUrl('create_or_update_report'),
        data: data_params,
        timeout: 50000
    })
}
export const get_report = (data_params, id) => {
    return apiAgent({
        method: "get",
        url: getApiUrl('get_report', {":id": id}),
        params: data_params
    })
}
export const get_all_reports = (data_params) => {
    return apiAgent({
        method: "get",
        url: getApiUrl('get_all_reports'),
        params: data_params
    })
}
